import axios from "../../services/axios";

class ContractService {
  static BASE_URL = "/customercontracts";

  static async getContracts() {
    try {
      const { data } = await axios.get(this.BASE_URL);
      return data;
    } catch (error) {
      console.error("Erro em getContracts:", error);
      throw error;
    }
  }

  static async getContract(id) {
    try {
      const { data } = await axios.get(`${this.BASE_URL}/${id}`);
      return data;
    } catch (error) {
      console.error("Erro em getContract:", error);
      throw error;
    }
  }

  static async createContract(contractData) {
    try {
      const { data } = await axios.post(this.BASE_URL, contractData);
      return data;
    } catch (error) {
      console.error("Erro em createContract:", error.response?.data || error);
      throw error;
    }
  }

  static async updateContract(id, contractData) {
    try {
      const { data } = await axios.put(`${this.BASE_URL}/${id}`, contractData);
      return data;
    } catch (error) {
      console.error("Erro em updateContract:", error.response?.data || error);
      throw error;
    }
  }

  static async deleteContract(id) {
    try {
      const { data } = await axios.delete(`${this.BASE_URL}/${id}`);
      return data;
    } catch (error) {
      console.error("Erro em deleteContract:", error.response?.data || error);
      throw error;
    }
  }

  static async uploadContractFile(id, file) {
    try {
      const formData = new FormData();
      formData.append("contract_file", file);

      const { data } = await axios.post(
        `${this.BASE_URL}/uploadfile/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return data;
    } catch (error) {
      console.error("Erro em uploadContractFile:", error.response?.data || error);
      throw error;
    }
  }

  static async getDiscounts() {
    try {
      const { data } = await axios.get("/discounts");
      return data;
    } catch (error) {
      console.error("Erro em getDiscounts:", error.response?.data || error);
      throw error;
    }
  }
}

export default ContractService;